// extracted by mini-css-extract-plugin
export default {"root":"CompanyInfoForm_root__Lp9MS","wrapper":"CompanyInfoForm_wrapper__a45Tt","item":"CompanyInfoForm_item__FomMq"};